<template>
  <div class="home">
    <menuBox :step="1"></menuBox>
    <div class="banner-box" id="home" ref="home">
      <div class="banner-text">
        <div class="title">Kesejahteraan, Kesehatan, Pekerjaan</div>
        <!-- <div class="subtitle">kesejahteraan, kesehatan, pekerjaan</div> -->
        <div class="text">
          PT Jasindo Citra Maju berupaya menjadi terdepan dalam memperjuangkan
          kesejahteraan dan kesehatan sosial, memberikan jaminan ketenagakerjaan
          sekaligus berupaya menciptakan kehidupan masyarakat yang lebih sehat
          dan harmonis.
        </div>
        <div class="btn" @click="goPage()">Hubungi kami</div>
      </div>
    </div>
    <div class="mission-box">
      <div class="mission-list">
        <div class="mission-item">
          <img src="../assets/mission-icon-1.png" alt="" />
          <div class="mission-title">
            Misi Kita
          </div>
          <div class="mission-content">
            Berkomitmen untuk meningkatkan kesejahteraan masyarakat, memastikan
            lapangan kerja, dan meningkatkan kesehatan dan keharmonisan sosial.
          </div>
        </div>
        <div class="mission-item">
          <img src="../assets/mission-icon-2.png" alt="" />
          <div class="mission-title">
            Ruang Lingkup Bisnis
          </div>
          <div class="mission-content">
            Menyediakan layanan kesejahteraan yang komprehensif, dukungan
            ketenagakerjaan dan program kesehatan sosial.
          </div>
        </div>
        <div class="mission-item">
          <img src="../assets/mission-icon-3.png" alt="" />
          <div class="mission-title">
            Tim Profesional
          </div>
          <div class="mission-content">
            Mengumpulkan pakar industri, kami berkomitmen terhadap solusi
            layanan sosial yang efisien dan inovatif.
          </div>
        </div>
        <div class="mission-item">
          <img src="../assets/mission-icon-4.png" alt="" />
          <div class="mission-title">
            Dampak Komunitas
          </div>
          <div class="mission-content">
            Melalui berbagai layanan dan proyek, kami secara aktif meningkatkan
            dan meningkatkan kualitas hidup masyarakat.
          </div>
        </div>
      </div>
      <div class="mission-msg">
        <img class="msg" src="../assets/mission-msg.png" alt="" />
        <div class="msg-box">
          <div class="msg-title">
            Pelopor Pembangunan Sosial
          </div>
          <div class="msg-content">
            Selama dua tahun terakhir, PT Jasindo Citra Maju berupaya memperluas
            jangkauan layanan kesejahteraan dan kesehatan sosial. Perusahaan
            telah menerapkan sejumlah program jaminan ketenagakerjaan untuk
            memberikan pelatihan kejuruan dan dukungan ketenagakerjaan guna
            membantu anggota masyarakat meningkatkan keterampilan mereka dan
            meningkatkan peluang kerja. Pada saat yang sama, dengan
            menyelenggarakan kegiatan pendidikan kesehatan dan menyediakan
            sumber daya medis yang diperlukan, perusahaan telah secara efektif
            meningkatkan tingkat kesehatan dan kualitas hidup masyarakat.
            Inisiatif-inisiatif ini menunjukkan komitmen berkelanjutan dan
            kontribusi positif perusahaan terhadap kesejahteraan sosial.
          </div>
          <div class="btn" @click="goPage()">
            Hubungi kami
          </div>
        </div>
        <img class="process" src="../assets/process.png" alt="" />
      </div>
    </div>
    <div class="business-box">
      <img class="title-img" src="../assets/Frame.png" alt="" />
      <div class="b-content">
        Sebagai pimpinan program pelatihan kerja bagi penyandang disabilitas di
        PT Jasindo Citra Maju, merupakan suatu kehormatan bagi saya untuk
        memperkenalkan prestasi yang telah kami capai. Kami memberikan pelatihan
        kejuruan yang komprehensif dalam keterampilan komputer, penulisan
        resume, keterampilan wawancara, dll., dan bekerja dengan bisnis lokal
        untuk menciptakan peluang magang dan kerja bagi para peserta. Sejak
        peluncuran proyek ini, kami telah membantu ratusan penyandang
        disabilitas meningkatkan keterampilan mereka, berhasil mendapatkan
        pekerjaan atau memulai usaha, sehingga mencapai kemandirian ekonomi dan
        partisipasi sosial, dan telah diakui secara luas oleh masyarakat.
      </div>
      <img class="user" src="../assets/user.png" alt="" />
      <div class="user-info">Lidya Nadia</div>
      <div class="user-name">
        Penanggung jawab program pelatihan ketenagakerjaan bagi penyandang
        disabilitas
      </div>
    </div>

    <div class="our-app-box" id="our-app">
      <div class="our-app-title">Aplikasi Kami</div>
      <div class="our-app-inner">
        <div class="our-app-shots">
          <img src="../assets/1.png" alt="Tangkapan layar FinanSmart 1" />
          <img src="../assets/2.png" alt="Tangkapan layar FinanSmart 2" />
          <img src="../assets/3.png" alt="Tangkapan layar FinanSmart 3" />
          <img src="../assets/4.png" alt="Tangkapan layar FinanSmart 4" />
        </div>
        <div class="our-app-content">
          <div class="our-app-head">
            <img
              class="our-app-logo"
              src="../assets/app-logo.png"
              alt="FinanSmart"
            />
            <div class="our-app-head-text">
              <div class="our-app-name">FinanSmart-Préstamo Flash</div>
              <div class="our-app-sub">Tentang aplikasi ini</div>
            </div>
          </div>
          <p class="our-app-intro">
            FinanSmart menyediakan layanan pinjaman yang efisien dan cepat
            kepada nasabah pinjaman di mana pun di negara ini. Layanan yang kami
            berikan dapat menyelesaikan masalah keuangan klien dalam hitungan
            menit. Pada saat yang sama, kami bekerja sepanjang waktu untuk
            segera menyetujui permohonan pinjaman dan menyetor dana ke rekening
            klien kami. Melalui layanan pengajuan pinjaman yang kami sediakan,
            ribuan nasabah pinjaman dapat memperoleh pinjaman dengan cara
            ternyaman dalam hitungan menit dan tanpa proses yang rumit.
          </p>
          <div class="our-app-adv-title">
            Keunggulan Aplikasi Pinjaman Pribadi Online FinanSmart:
          </div>
          <ul class="our-app-list">
            <li>
              Tidak diperlukan riwayat kredit: Pengguna dapat mengajukan
              pinjaman tanpa tinjauan atau persetujuan lembaga kredit.
            </li>
            <li>Tidak diperlukan jaminan atau pembayaran di muka</li>
            <li>
              Proses pinjaman yang aman: Pengguna memiliki akses ke semua detail
              terkait pinjaman fleksibel.
            </li>
            <li>
              Persetujuan Pinjaman Cepat: Memberikan persetujuan pinjaman instan
              memastikan kami akan menghubungi Anda kembali dalam hitungan
              menit.
            </li>
            <li>
              Proses aplikasi sederhana: mengisi informasi untuk mengajukan
              pinjaman, menyelesaikan penilaian dan pengguna dapat memperoleh
              pinjaman kredit
            </li>
            <li>
              Berbagai metode pembayaran: Pengguna dapat memilih paket
              pembayaran yang fleksibel sesuai dengan situasi aktual mereka.
            </li>
            <li>
              Suku bunga yang berbeda: melalui evaluasi kredit peminjam, suku
              bunga akhir atau biaya pengelolaan pinjaman.
            </li>
          </ul>
          <div class="our-app-actions">
            <a
              class="our-app-btn our-app-btn-primary"
              href="https://finansmartauto.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Situs aplikasi
            </a>
            <a
              class="our-app-btn our-app-btn-outline"
              href="https://play.google.com/store/apps/details?id=com.finance.smart.financial.nice&hl=id&gl=id"
              target="_blank"
              rel="noopener noreferrer"
            >
              Google Play
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="partner-box">
      <div class="p-title">Bagaimana kami dapat membantu Anda</div>
      <!-- <div class="p-subtitle">
        Bagaimana cara mendapatkan dukungan finansial?
      </div> -->
      <div class="partner-list">
        <div class="item">
          <div class="tit">
            <span>1 </span>Bagaimana cara mendapatkan dukungan finansial?
          </div>
          <div class="msg">
            Perusahaan memberikan bantuan keuangan untuk proyek kesejahteraan
            masyarakat tertentu, termasuk sponsorship dan donasi, untuk
            mendukung pengembangan masyarakat dan peningkatan kesejahteraan.
          </div>
        </div>
        <div class="item">
          <div class="tit">
            <span>2 </span>Bisakah saya mendapatkan bantuan teknis?
          </div>
          <div class="msg">
            Memberikan dukungan teknis profesional, termasuk layanan TI,
            manajemen proyek, dan pelatihan keterampilan, untuk meningkatkan
            efisiensi dan dampak proyek kesejahteraan masyarakat.
          </div>
        </div>
        <div class="item">
          <div class="tit">
            <span>3 </span>Bagaimana cara mendapatkan sumber daya pelatihan?
          </div>
          <div class="msg">
            Perusahaan menyediakan berbagai sumber pelatihan, termasuk ceramah
            pengetahuan profesional dan pelatihan keterampilan, untuk
            meningkatkan kemampuan operasional dan kualitas layanan organisasi
            kesejahteraan masyarakat.
          </div>
        </div>
        <div class="item">
          <div class="tit"><span>4 </span>Apa saja peluang kerjasamanya?</div>
          <div class="msg">
            Jelajahi peluang kemitraan dengan perusahaan, termasuk
            menyelenggarakan acara dan proyek bersama untuk memperluas dampak
            filantropis dan berbagi sumber daya.
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="deveopment-box">
      <div class="d-title">Development Goals</div>
      <div class="d-content">
        Embark on a journey of innovation with AZALEA TECH, where our
        development goal is to redefine the technological landscape. We aspire
        to be at the forefront of fearless innovation, transforming digital
        experiences globally. Our commitment extends to empowering businesses,
        leading in sustainable technology, and cultivating a diverse and
        talented team. Together, we collaborate for a global impact, creating a
        future where possibilities are limitless. Join us in shaping tomorrow's
        potential at AZALEA TECH.
      </div>
    </div> -->
    <footerBox ref="footerBox"></footerBox>
  </div>
</template>

<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";

export default {
  name: "App",
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    goPage() {
      this.$refs.footerBox.selectMenu(5);
    },
  },
};
</script>

<style lang="less" scoped>
.banner-box {
  background-image: url(../assets/swiper-1.png);
  height: 600px;
  background-size: 100% 100%;
  position: relative;

  .banner-text {
    margin-left: 360px;
    padding-top: 165px;
    width: 700px;
    text-align: center;
    .title {
      font-size: 36px;
      font-family: Inter, Inter;
      font-weight: normal;
      color: #ce3723;
      span {
        color: #333333;
      }
    }

    .subtitle {
      font-size: 32px;
      font-family: Inter, Inter;
      font-weight: normal;
      color: #1e1e1e;
    }
    .btn {
      width: 136px;
      height: 44px;
      text-align: center;
      line-height: 44px;
      font-size: 16px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      background: #ce3723;
      border-radius: 30px;
      margin: auto;
      margin-top: 16px;
    }
    .text {
      font-size: 16px;
      font-family: Inter, Inter;
      font-weight: 400;
      color: #959595;
      margin-top: 16px;
      padding: 0 10px;
    }
  }
}
.mission-box {
  padding: 0 360px;
  background: #f2f2f2;
  padding-bottom: 100px;
  .mission-list {
    height: 450px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .mission-item {
      background-color: #fff;
      width: 250px;
      height: 226px;
      text-align: center;
      img {
        width: 60px;
        height: 60px;
        margin-top: -25px;
      }
      .mission-title {
        font-size: 20px;
        font-family: Inter, Inter;
        font-weight: normal;
        color: #1e1e1e;
        margin-top: 12px;
      }
      .mission-content {
        font-size: 14px;
        font-family: Inter, Inter;
        font-weight: 400;
        color: #959595;
        line-height: 16px;
        margin-top: 24px;
        padding: 0 20px;
      }
    }
  }
  .mission-msg {
    height: 300px;
    background-color: #fff;
    .msg {
      height: 100%;
      float: left;
    }
    .process {
      float: left;
      width: 180px;
      height: 180px;
      margin-top: 57px;
      margin-left: 30px;
    }
    .msg-box {
      margin-left: 40px;
      max-width: 580px;
      float: left;
      .msg-title {
        font-size: 20px;
        font-family: Inter, Inter;
        font-weight: normal;
        color: #1e1e1e;
        line-height: 24px;
        margin-top: 20px;
      }
      .msg-content {
        font-size: 14px;
        font-family: Inter, Inter;
        font-weight: 400;
        color: #959595;
        line-height: 16px;
        margin-top: 16px;
      }
      .btn {
        width: 136px;
        height: 44px;
        text-align: center;
        line-height: 44px;
        font-size: 16px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        background: #ce3723;
        border-radius: 30px;
        margin-top: 20px;
      }
    }
  }
}
.user-serve-box {
  margin-top: 100px;
  background-image: url(../assets/swiper-3.png);
  height: 627px;
  overflow: hidden;
  background-size: 100% 100%;
  .title {
    font-size: 32px;
    width: 660px;
    font-family: Roboto-Bold, Roboto;
    font-weight: bold;
    color: #333333;
    text-align: left;
    margin-left: 900px;
    margin-top: 40px;
  }

  .subtitle {
    font-size: 26px;
    margin-top: 24px;
    text-align: center;
    font-weight: 500;
    color: #999999;
  }

  .server-list-box {
    margin-left: 900px;
    text-align: left;
    margin-top: 34px;
    .tit {
      font-size: 24px;
      font-family: Roboto-Regular, Roboto;
      font-weight: 400;
      color: #333333;
    }
    .item {
      font-size: 20px;
      font-family: Roboto-Regular, Roboto;
      font-weight: 400;
      color: #999999;
      margin-top: 20px;
      img {
        width: 16px;
        height: 16px;
      }
    }
  }
}

.business-box {
  background-image: url(../assets/swiper-2.png);
  height: 410px;
  overflow: hidden;
  background-size: 100% 100%;
  text-align: center;
  .title-img {
    width: 80px;
    height: 80px;
    margin-top: 33px;
  }
  .b-content {
    font-size: 14px;
    font-family: Inter, Inter;
    font-weight: 400;
    color: #ffffff;
    line-height: 18px;
    padding: 0 360px;
    margin-top: 36px;
  }
  .user {
    width: 70px;
    height: 70px;
    margin-top: 30px;
    border-radius: 50%;
  }
  .user-info {
    font-size: 14px;
    font-family: Inter, Inter;
    font-weight: 500;
    color: #ffffff;
    line-height: 16px;
    margin-top: 8px;
  }
  .user-name {
    font-size: 12px;
    font-family: Inter, Inter;
    font-weight: 400;
    color: #ffffff;
    line-height: 14px;
    margin-top: 8px;
  }
}

.our-app-box {
  padding: 80px 360px 70px;
  background: #f2f2f2;

  .our-app-title {
    font-size: 32px;
    font-family: Inter, Inter;
    font-weight: normal;
    color: #1e1e1e;
    line-height: 38px;
    text-align: center;
  }

  .our-app-inner {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 56px;
    margin-top: 40px;
  }

  .our-app-shots {
    flex-shrink: 0;
    width: 440px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;

    img {
      width: 100%;
      display: block;
      border-radius: 12px;
      background: #fff;
      box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06);
    }
  }

  .our-app-content {
    flex: 1;
    min-width: 0;
    background: #fff;
    border-radius: 12px;
    padding: 32px 36px 36px;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.04);
  }

  .our-app-head {
    display: flex;
    align-items: center;
    gap: 18px;
    margin-bottom: 20px;
  }

  .our-app-logo {
    width: 72px;
    height: 72px;
    border-radius: 16px;
    flex-shrink: 0;
    object-fit: contain;
  }

  .our-app-name {
    font-size: 22px;
    font-family: Inter, Inter;
    font-weight: 500;
    color: #1e1e1e;
    line-height: 26px;
  }

  .our-app-sub {
    font-size: 16px;
    font-family: Inter, Inter;
    font-weight: 500;
    color: #ce3723;
    line-height: 22px;
    margin-top: 6px;
  }

  .our-app-intro {
    font-size: 14px;
    font-family: Inter, Inter;
    font-weight: 400;
    color: #959595;
    line-height: 22px;
    margin: 0;
  }

  .our-app-adv-title {
    font-size: 16px;
    font-family: Inter, Inter;
    font-weight: 500;
    color: #1e1e1e;
    line-height: 22px;
    margin-top: 22px;
    margin-bottom: 12px;
  }

  .our-app-list {
    margin: 0;
    padding-left: 18px;
    font-size: 14px;
    font-family: Inter, Inter;
    font-weight: 400;
    color: #959595;
    line-height: 20px;

    li {
      margin-bottom: 10px;
      padding-left: 4px;

      &::marker {
        color: #ce3723;
      }
    }
  }

  .our-app-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    margin-top: 28px;
  }

  .our-app-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 148px;
    height: 44px;
    padding: 0 24px;
    font-size: 16px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    border-radius: 30px;
    text-decoration: none;
    box-sizing: border-box;
    transition: opacity 0.2s;

    &:hover {
      opacity: 0.9;
    }
  }

  .our-app-btn-primary {
    color: #ffffff;
    background: #ce3723;
    border: 1px solid #ce3723;
  }

  .our-app-btn-outline {
    color: #ce3723;
    background: #ffffff;
    border: 1px solid #ce3723;
  }
}

.partner-box {
  padding: 80px 360px;
  text-align: center;
  padding-bottom: 50px;
  .p-title {
    font-size: 32px;
    font-family: Inter, Inter;
    font-weight: normal;
    color: #1e1e1e;
    line-height: 38px;
  }

  .p-subtitle {
    font-size: 16px;
    font-family: Inter, Inter;
    font-weight: 500;
    color: #ce3723;
    line-height: 19px;
    margin-top: 13px;
  }

  .partner-list {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-top: 35px;
    .item:nth-child(odd) {
      margin-right: 70px;
    }
    .item {
      width: 550px;
      text-align: left;

      margin-bottom: 35px;
      .tit {
        font-size: 20px;
        font-family: Inter, Inter;
        font-weight: 500;
        color: #1e1e1e;
        line-height: 24px;
        span {
          color: #ce3723;
        }
      }
      .msg {
        font-size: 14px;
        font-family: Inter, Inter;
        font-weight: 400;
        color: #959595;
        line-height: 16px;
        margin-top: 18px;
      }
    }
  }
}
.deveopment-box {
  padding: 0 360px;
  height: 650px;
  overflow: hidden;
  background: linear-gradient(#fde2e2, #fffbef);
  .d-title {
    font-size: 48px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    text-align: center;
    margin-top: 100px;
    margin-bottom: 24px;
  }
  .d-content {
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
  }
}
</style>
